import { CharacterRole } from 'app/frontend/types/custom'
import ApplicationRole from 'app/frontend/types/custom/ApplicationRole'
import capitalize from 'lodash/capitalize'

interface Props {
  role: CharacterRole | ApplicationRole
  size?: 'small' | 'medium' | 'large' | 'custom'
  className?: string
}

const CharacterRoleIcon = ({ role, size, className }: Props) => {
  const sizeStyles = {
    small: 'w-4 h-4 min-w-[1rem] min-h-[1rem]',
    medium: 'w-6 h-6 min-w-[1.5rem] min-h-[1.5rem]',
    large: 'w-8 h-8 min-w-[2rem] min-h-[2rem]',
    custom: '',
  }[size ?? 'medium']

  return (
    <img
      src={`https://data.wowaudit.com/img/${capitalize(role)}.png`}
      className={`${sizeStyles} ${className ?? ''}`}
      alt={role}
    />
  )
}

export default CharacterRoleIcon
